import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {RoutedTaskMarker} from "../../../map/models/routed-task-marker.model";
import {MapsCommonService} from "../../../map/services/mapsCommon.service";
import {MapPolygonDrawService, MapSelectionDrawSession} from "../../../map/services/map-polygon-draw.service";
import {PlanningAlertsService} from "../../../planning/services/planning-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {VisitScheduleActivityDetailsModel} from "../../models/visit-plan-route.model";
import {VisitPlanHttpService} from "../../angular/services/visit-plan-http.service";
import {take} from "rxjs";
import {AccountModel} from "../../../account/angular/models/account.model";
import {MapUtilsService} from "../../../commons/angular/services/map-utils.service";
import {escapeHtml} from "../../../commons/utils/html-escape.util";
import {VisitScheduleResourceHolderExt} from "../../models/visit-schedule-resource-holder-ext.model";
import {StopsClusterModel} from "../../../planning/models/stops-cluster.model";

declare var MarkerClusterer: any;

export class VisitPlanRoutesMapComponent implements IController {
  visitPlan: VisitPlanModel;
  routes: any;
  jobs: any;
  agents: any;
  panelJobs: any;
  depots: any;
  stopsClusters?: any;
  hiddenRoutesAgentIds: any;
  unRoutedStops: any;
  serviceAreas: any;
  suggestions: any;
  selectedJobIds: any;
  selectedActivityId: any;
  zoomActivityId?: string;
  highlightedActivityId: any;
  isDisplayRetrips: boolean;
  isValidateRouteVehicles: boolean;
  isAllowDraggingStops: boolean;
  isAllowDraggingIntoDispatchedRoute: boolean;
  agentColorMap: { [key: string]: string };
  onRoutedJobSelect: Function;
  programTypeAliasMap: { [key: string]: string };
  onPanelJobSelect: Function;
  onUnRoutedMultipleJobsSelect: Function;
  onActivityHover: Function;
  onActivityHighlight: Function;
  onRoutedActivitySelect: Function;
  onAddStopsToRoute: Function;
  onHiddenRoutesAgentIdsChange: Function;
  onSelectRoute: Function;
  onViewJob: Function;
  selectedServiceIdsChanged: Function;
  onMoveActivity: Function;


  public circles = [];
  private siteLocation: any;
  private defaultPolygonOptions: any = {
    fillColor: '#676767',
    fillOpacity: 0.4,
    strokeWeight: 2,
    strokeColor: '#6060FB',
    clickable: true,
    editable: false,
    zIndex: 3
  }
  private mapTypeIds: any = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  };
  private purposeToColor = {
    Pickup: '#FF9936',
    Dropoff: '#2196F3',
    Operation: '#35C6AC',
    Start: '#616161',
    End: '#616161'
  };
  private infowindow: any = new google.maps.InfoWindow();
  private jobInfoWindow: any;
  private mapPolygonsWindow: any;
  private filters: any = {
    traffic: false,
    satellite: false,
    routes: true,
    agents: true,
    serviceAreas: true,
    depots: true,
    accounts: true,
    unRouted: true,
    clusters: false
  };
  private clusterGridSizes: any = 70;
  drawSession: MapSelectionDrawSession;
  private map: any;
  private tooltipOptions: any = {
    visible: false
  };
  private routedMarkers: any = [];
  private unRoutedMarkers: any = [];
  private polylines: any = [];
  private poligons: any = [];
  private routedMarkersControl: any = {};
  private unRoutedMarkersControl: any = {};
  private polylinesControl: any = {};
  private unRoutedMarkersEvents: any;
  private depotsEvents: any;
  private polygonEvents: any;
  private clusterEvents: any;
  private isReady: boolean;
  private selectedServiceIds: any;
  private mapPolygons: any[] = [];
  private routesDataLayerRef: any;
  private jobInfoWindowModel: RoutedTaskMarker;
  private hoveringTaskId: any;
  private depotMarkers: any;
  private mapRef: any;
  public unRoutedDataLayerRef: any;
  public markerCluster: any;
  public jobsMap: any;
  public userZoneId: string;
  public timezoneOffset: number;
  public agentsHomeAddress: any[];
  public markerEvents: any;
  public agentsInfoWindows: any[] = [];
  public accountMarkers: any[];
  public accountMarkerEvents: any;
  public accountsInfoWindows: any[] = [];

  constructor(private mapsCommonService: MapsCommonService, private mapPolygonDrawService: MapPolygonDrawService, private $log, private splitService: SplitService,
              private $timeout: ITimeoutService, private $filter,
              private planningAlertsService: PlanningAlertsService,
              private confirmDialogService: ConfirmDialogService,
              private mapUtilsService: MapUtilsService, private moment, private visitPlanHttpService: VisitPlanHttpService) {
  }

  $onDestroy() {
    if (this.drawSession) {
      this.drawSession.destroy();
    }
  }

  $onInit() {

    this.userZoneId = this.moment.tz.guess();
    this.programTypeAliasMap = this.splitService.getProgramCodesMap();

    this.timezoneOffset = this.moment.tz.zone(this.userZoneId).utcOffset(this.moment().valueOf()) - this.moment.tz.zone(this.visitPlan.zoneId).utcOffset(this.moment().valueOf());

    this.drawSession = this.mapPolygonDrawService.createSelectionSession({
      $timeout: this.$timeout,
      polygonOptions: this.defaultPolygonOptions,
      onRectangleComplete: (bounds) => {
        const jobIds = this.getJobIdsByBounds(bounds);
        if (jobIds.length && _.isFunction(this.onUnRoutedMultipleJobsSelect)) {
          this.$timeout(0).then(() => {
            this.onUnRoutedMultipleJobsSelect({jobIds: jobIds});
          });
        }
      },
      onPolygonComplete: () => {
      },
      onDeleteCustomPolygons: () => {
      }
    });

    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.jobInfoWindow = this.mapsCommonService.initActiveWindow({disableAutoPan: false});
    this.infowindow.setOptions({disableAutoPan: false})
    this.mapPolygonsWindow = this.mapsCommonService.initActiveWindow({disableAutoPan: false});

    this.jobsMap = _.keyBy(this.jobs, (j) => {
      return j.id
    })

    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      doCluster: false,
      events: {
        idle: (map) => {
          if (!this.isReady) {
            this.isReady = true;
            this.mapRef = map;
            google.maps.event.trigger(map, 'resize');
            this.centerMap();
            this.drawSession.setMapInstance(map);
            this.drawSession.enable();
          }
        }
      },
      dataLayerCallback: (layer) => {
        this.routesDataLayerRef = layer;

        // Layer - Right Click Event
        this.routesDataLayerRef.addListener("rightclick", (event) => {
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            this.onViewJob({jobId: jobId});
          })
        });

        let dragMoveListener: google.maps.MapsEventListener | null = null;
        let dragFeature: google.maps.Data.Feature | null = null;
        let initialMarkerPosition: any;
        let isDragging = false;
        let wheelListener = null;

        this.routesDataLayerRef.addListener("mousedown", (event) => {
          const feature = event.feature;
          if (feature.getGeometry().getType() === "Point") {
            initialMarkerPosition = feature.getGeometry()?.get() as google.maps.LatLng;
            this.map.options.draggable = false;

            _.forEach(this.mapPolygons, (mapPolygon) => {
              mapPolygon.visible = false;
            });

            dragFeature = feature;
            dragMoveListener = this.mapRef.addListener("mousemove", (moveEvent) => {

              isDragging = true;
              if (dragFeature) {
                dragFeature.setGeometry(
                  new google.maps.Data.Point(moveEvent.latLng)
                );
                this.mapUtilsService.autoPanIfNearEdge(moveEvent.pixel, this.mapRef);
              }
            });

          }
        });

        this.routesDataLayerRef.addListener("mouseup", (event) => {
          const self = this;
          this.map.options.draggable = true;
          const marker = event.feature;

          _.forEach(this.mapPolygons, (mapPolygon) => {
            mapPolygon.visible = this.filters.serviceAreas;
          });

          this.$timeout(() => {
          }, 0);
          if (!isDragging) {
            cancelDrag();
            return;
          }

          if (!marker || marker.getGeometry().getType() !== "Point") {
            cancelDrag();
            return;
          }

          const markerPosition = marker?.getGeometry()?.get();
          const routePolyline = this.mapUtilsService.getClosestPolyline(this.routesDataLayerRef, markerPosition);
          if (!routePolyline) {
            cancelDrag();
            return;
          }

          const fromRouteId = marker.getProperty("routeId");
          const toRouteId = routePolyline.getProperty("routeId");

          const fromRoute = this.routes.find((route) => route.id === fromRouteId);
          const toRoute = this.routes.find((route) => route.id === toRouteId);

          if (fromRoute.locked || toRoute.locked) {
            this.planningAlertsService.routeIsLocked();
            cancelDrag();
            return;
          }

          if (!this.isAllowDraggingIntoDispatchedRoute && (fromRoute.status === 'DISPATCHED' || toRoute.status === 'DISPATCHED' || fromRoute.status === 'PARTIAL_DISPATCHED' || toRoute.status === 'PARTIAL_DISPATCHED')) {
            this.planningAlertsService.routeIsDispatchedOrPartialDispatchedInfo();
            cancelDrag();
            return;
          }


          const jobIds = marker.getProperty("jobIds") ? marker.getProperty("jobIds") : [marker.getProperty("jobId")];

          const itemJobs = _.map(jobIds, (id) => {
            return this.jobsMap[id];
          })

          for (let job of itemJobs) {
            if (job.lockedRouteId) {
              cancelDrag();
              return;
            }
          }

          const toRouteActivities = toRoute.activities.filter(activity => (activity.type !== 'START') && (activity.type !== 'END'))

          const itemSkills = _.flatMap(itemJobs, (j) => {
            return j.skills || [];
          })

          const currentRouteSkills = toRoute.resource?.allocationSkills;
          if (currentRouteSkills && !!_.difference(itemSkills, currentRouteSkills).length) {
            this.planningAlertsService.noMatchingSkillsInfo();
            cancelDrag();
            return false
          }

          let isValidateRouteVehicle = false;
          for (let job of itemJobs) {
            if (this.isValidateRouteVehicles && !!toRoute.resource?.vehicleClass &&
              job.allowedVehicleTypes?.length && !job.allowedVehicleTypes.includes(toRoute.resource?.vehicleClass)) {
              isValidateRouteVehicle = true;
              break;
            }
          }

          if (isValidateRouteVehicle) {
            const confirmDialogDescription = itemJobs.length > 1 ? "Services vehicle types do not match route resource vehicle type. Are you sure you want to proceed?" :
              "Service vehicle types do not match route resource vehicle type. Are you sure you want to proceed?"
            this.confirmDialogService.confirm("Confirm",
              confirmDialogDescription)
              .then(() => {
                activityDrop();
              })
              .catch(() => {
                cancelDrag();
                return;
              });
          } else {
            activityDrop();
          }

          function cancelDrag() {
            setMarkerToInitialPosition();

            if (dragMoveListener) {
              google.maps.event.removeListener(dragMoveListener);
              dragMoveListener = null;
            }

            if (wheelListener) {
              self.mapRef.getDiv().removeEventListener("wheel", wheelListener);
              wheelListener = null;
            }

            isDragging = false;
            dragFeature = null;
          }

          function setMarkerToInitialPosition() {
            if (dragFeature && initialMarkerPosition) {
              dragFeature.setGeometry(
                new google.maps.Data.Point(initialMarkerPosition)
              );
            }
          }

          function activityDrop() {
            if (routePolyline && fromRouteId !== toRouteId) {

              const routePolylinePath = routePolyline
                .getGeometry()
                .getArray()
                .map(latLng => ({lat: latLng.lat(), lng: latLng.lng()}));

              self.onMoveActivity({
                jobIds: jobIds,
                fromRouteId: fromRouteId,
                toRouteId: toRouteId,
                toOrderedIds: self._activityOrderIds(marker, toRouteActivities, routePolylinePath)
              });
            }

            cancelDrag();
          }

        });

        // Layer - Click Event
        this.routesDataLayerRef.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            const routeId = event.feature.getProperty("routeId");
            const jobIds = event.feature.getProperty("jobId") ? [event.feature.getProperty("jobId")] : event.feature.getProperty("jobIds");
            const id = event.feature.getProperty("id");
            const type = event.feature.getProperty("type");
            this.onSelectRoute({routeId: routeId, $event: event});
            if (type === 'STOP' || type === 'GROUP') {
              this.onUnRoutedMultipleJobsSelect({jobIds: jobIds});

              // const route = _.find(this.routes, (r) => {
              //   return r.id === routeId;
              // })
              // if (!!route) {
              //   const activity = _.find(route.activities, (a) => {
              //     return a.id === id;
              //   })
              //   this.onActivityHighlight({activity: activity});
              // }
              // this.onRoutedJobSelect({jobId: jobId});
            }
          })
        });

        // Layer - Mouseover
        this.routesDataLayerRef.addListener("mouseover", (event) => {
          if (isDragging) return;
          const activityType = event.feature.getProperty("type");
          if (activityType === 'STOP' || activityType === 'GROUP') {
            this.$timeout(0).then(() => {
              const activity = angular.copy(event.feature.getProperty("ref"));
              const jobId = event.feature.getProperty("jobId");
              const agentName = event.feature.getProperty("agentName");
              const geo = event.feature.getGeometry().get();

              const routeId = event.feature.getProperty("routeId");
              const route = this.routes.find((r) => {
                return r.id === routeId;
              })

              const details = route?.activityDetails?.find((ad) => {
                return ad.activityId === activity.id;
              })
              this.setActivityInfoWindow(jobId, agentName, activity, geo.lat(), geo.lng(), details);
            })
          }
        });

        // Layer - Mouseout
        this.routesDataLayerRef.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this.unsetActivityInfoWindow();
          });
        });

        if (this.routes) {
          this.setRoutes(this.routes);
          this.centerMap();
        }

      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        scaleControl: true,
        zoomControl: true,
        mapTypeControl: false
      },
      clusterOptions: {
        imagePath: 'https://raw.githubusercontent.com/googlemaps/js-marker-clusterer/gh-pages/images/m',
        gridSize: this.clusterGridSizes,
        maxZoom: 23,
        styles: this.mapsCommonService.getClusterIcons()
        // zoomOnClick: false,
      },
      bounds: {},
      unRoutedLayerCallback: (layer) => {
        this.unRoutedDataLayerRef = layer;

        let dragMoveListener: google.maps.MapsEventListener | null = null;
        let dragFeature: google.maps.Data.Feature | null = null;
        let initialMarkerPosition: any;
        let isDragging = false;
        let wheelListener = null;

        this.unRoutedDataLayerRef.addListener("mousedown", (event) => {
          const feature = event.feature;
          if (feature.getGeometry().getType() === "Point") {
            isDragging = true;
            this.map.options.draggable = false;
            initialMarkerPosition = feature.getGeometry().get() as google.maps.LatLng;

            dragFeature = feature;
            dragMoveListener = this.mapRef.addListener("mousemove", (moveEvent) => {
              if (dragFeature) {
                dragFeature.setGeometry(
                  new google.maps.Data.Point(moveEvent.latLng)
                );
                this.mapUtilsService.autoPanIfNearEdge(moveEvent.pixel, this.mapRef);
              }
            });


            // const mapDiv = this.mapRef.getDiv();
            // wheelListener = (e) => {
            //   e.preventDefault();
            //   const currentZoom = this.mapRef.getZoom();
            //   if (e.deltaY < 0) {
            //     this.mapRef.setZoom(currentZoom + 1); // zoom in
            //   } else {
            //     this.mapRef.setZoom(currentZoom - 1); // zoom out
            //   }
            // };
            // mapDiv.addEventListener("wheel", wheelListener, {passive: false});
          }
        });

        this.unRoutedDataLayerRef.addListener("mouseup", (event) => {
          const self = this;
          this.map.options.draggable = true;

          const marker = event.feature;
          if (!marker || marker.getGeometry().getType() !== "Point") {
            cancelDrag();
            return;
          }

          const markerPosition = marker?.getGeometry()?.get();
          const routePolyline = this.mapUtilsService.getClosestPolyline(this.routesDataLayerRef, markerPosition);
          if (!routePolyline) {
            cancelDrag();
            return;
          }
          const toRouteId = routePolyline.getProperty("routeId");

          const toRoute = this.routes.find((route) => route.id === toRouteId);

          if (toRoute.locked) {
            this.planningAlertsService.routeIsLocked();
            cancelDrag();
            return;
          }

          if (!this.isAllowDraggingIntoDispatchedRoute && (toRoute.status === 'DISPATCHED' || toRoute.status === 'PARTIAL_DISPATCHED')) {
            this.planningAlertsService.routeIsDispatchedOrPartialDispatchedInfo();
            cancelDrag();
            return;
          }


          const jobIds = marker.getProperty("jobIds") ? marker.getProperty("jobIds") : [marker.getProperty("jobId")];

          const itemJobs = _.map(jobIds, (id) => {
            return this.jobsMap[id];
          })

          for (let job of itemJobs) {
            if (job.lockedRouteId) {
              cancelDrag();
              return;
            }
          }

          const toRouteActivities = toRoute.activities.filter(activity => (activity.type !== 'START') && (activity.type !== 'END'))

          const itemSkills = _.flatMap(itemJobs, (j) => {
            return j.skills || [];
          })

          const currentRouteSkills = toRoute.resource?.allocationSkills;
          if (currentRouteSkills && !!_.difference(itemSkills, currentRouteSkills).length) {
            this.planningAlertsService.noMatchingSkillsInfo();
            cancelDrag();
            return;
          }

          let isValidateRouteVehicle = false;
          for (let job of itemJobs) {
            if (this.isValidateRouteVehicles && !!toRoute.resource?.vehicleClass &&
              job.allowedVehicleTypes?.length && !job.allowedVehicleTypes.includes(toRoute.resource?.vehicleClass)) {
              isValidateRouteVehicle = true;
              break;
            }
          }

          if (isValidateRouteVehicle) {
            const confirmDialogDescription = itemJobs.length > 1 ? "Services vehicle types do not match route resource vehicle type. Are you sure you want to proceed?" :
              "Service vehicle types do not match route resource vehicle type. Are you sure you want to proceed?"
            this.confirmDialogService.confirm("Confirm",
              confirmDialogDescription)
              .then(() => {
                activityDrop();
              })
              .catch(() => {
                cancelDrag();
                return;
              });
          } else {
            activityDrop();
          }

          function cancelDrag() {
            setMarkerToInitialPosition();

            if (dragMoveListener) {
              google.maps.event.removeListener(dragMoveListener);
              dragMoveListener = null;
            }

            if (wheelListener) {
              self.mapRef.getDiv().removeEventListener("wheel", wheelListener);
              wheelListener = null;
            }

            isDragging = false;
            dragFeature = null;
          }

          function setMarkerToInitialPosition() {
            if (dragFeature && initialMarkerPosition) {
              dragFeature.setGeometry(
                new google.maps.Data.Point(initialMarkerPosition)
              );
            }
          }

          function activityDrop() {
            if (routePolyline) {

              const routePolylinePath = routePolyline
                .getGeometry()
                .getArray()
                .map(latLng => ({lat: latLng.lat(), lng: latLng.lng()}));

              self.onMoveActivity({
                jobIds: jobIds,
                fromRouteId: undefined,
                toRouteId: toRouteId,
                toOrderedIds: self._activityOrderIds(marker, toRouteActivities, routePolylinePath)
              });
            }

            cancelDrag();
          }

        });

        // Layer - Click Event
        this.unRoutedDataLayerRef.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            // const routeId = event.feature.getProperty("routeId");
            // const jobIds = event.feature.getProperty("jobId") ? [event.feature.getProperty("jobId")] : event.feature.getProperty("jobIds");
            // const id = event.feature.getProperty("id");
            // const type = event.feature.getProperty("type");
            // this.onSelectRoute({routeId: routeId, $event: event});
            // if (type === 'STOP' || type === 'GROUP') {
            //   this.onUnRoutedMultipleJobsSelect({jobIds: jobIds});
            //
            //   // const route = _.find(this.routes, (r) => {
            //   //   return r.id === routeId;
            //   // })
            //   // if (!!route) {
            //   //   const activity = _.find(route.activities, (a) => {
            //   //     return a.id === id;
            //   //   })
            //   //   this.onActivityHighlight({activity: activity});
            //   // }
            //   // this.onRoutedJobSelect({jobId: jobId});
            // }
          })
        });

        // Add events connection to data layer
        this.unRoutedDataLayerRef.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            const selectedIds = _.includes(this.selectedJobIds, jobId) ? _.filter(this.selectedJobIds, (id) => {
              return id !== jobId;
            }) : (this.selectedJobIds || []).concat([jobId]);

            this.onPanelJobSelect({selectedIds: selectedIds});
          });
        });

        // Add events connection to data layer
        this.unRoutedDataLayerRef.addListener("rightclick", (event) => {
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            this.onViewJob({jobId: jobId})
          });
        });

        this.unRoutedDataLayerRef.addListener("mouseover", (event) => {
          if (isDragging) return;
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            const agentName = event.feature.getProperty("agentName");
            const model = event.feature.getProperty("ref");
            const coordinates = event.feature.getProperty('coordinates');
            this.setActivityInfoWindow(jobId, agentName, model, coordinates.lat, coordinates.lng);
          })
        });

        this.unRoutedDataLayerRef.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this.unsetActivityInfoWindow();
          })
        });

        if (this.panelJobs?.length) {
          this.setUnRoutedMarkersOnLayer(this.panelJobs);
          this.centerMap();
        }


      },
    };
    this.depotsEvents = {
      mouseover: (marker, event, model, args) => {
        const map = marker.map;
        this.infowindow.setContent(escapeHtml(model.name));
        this.infowindow.open(map, marker);
      },
      mouseout: (marker, event, model, args) => {
        this.infowindow.close();
      }
    };
    this.polygonEvents = {
      mouseover: (marker, event, model) => {
        const map = marker.map;
        const contentString =
          '<div style="text-align: center; width: 100%">' + escapeHtml(_.get(model, 'fill.name')) + '</div>';
        this.infowindow.setPosition(this.mapsCommonService.getPolygonBounds(model.path).getCenter());
        this.infowindow.setContent(contentString);
        this.infowindow.open(map, marker);
      },
      mouseout: () => {
        this.infowindow.close();
      }
    };

    if (!this.routes) {
      this.routes = [];
    }

    if (!this.unRoutedStops) {
      this.unRoutedStops = [];
    }

    // _addRoutes(this.routes);

    if (this.routes) {
      this.setRoutes(this.routes);
      this.centerMap();
    }

    this.markerEvents = {
      mouseover: (marker, event, model, args) => {
        this._setAgentsInfoWindows([model.id]);
      },
      mouseout: (marker, event, model, args) => {
        this._clearAllAgentsInfoWindows();
      }
    };

    this.accountMarkerEvents = {
      mouseover: (marker, event, model, args) => {
        this._setAccountsInfoWindows([model]);
      },
      mouseout: (marker, event, model, args) => {
        this._clearAllAccountsInfoWindows();
      }
    };

    this.depotMarkers = this.mapsCommonService.getDepotMarkers(this.depots);

    this.visitPlanHttpService.getVisitPlanAccountsMapData(this.visitPlan.id)
      .pipe(take(1))
      .subscribe((accounts: AccountModel[]) => {
        this.accountMarkers = this.mapsCommonService.getAccountMarkers(accounts);
      });

    // this.routesDataLayerRef.setMap(null);
    // this.routesDataLayerRef.setMap(this.mapRef);
  }

  $onChanges(changes) {
    // Routes Changed
    if (changes.routes && !changes.routes.isFirstChange()) {

      const currentRoutes = changes.routes.currentValue;
      const previousRoutes = changes.routes.previousValue;

      const routesToAdd = _.differenceBy(currentRoutes, previousRoutes, 'id');
      const routesToRemove = _.differenceBy(previousRoutes, currentRoutes, 'id');

      const routesDelta = _.differenceBy(currentRoutes, routesToAdd.concat(routesToRemove), 'id');
      const routesToUpdate = _.filter(routesDelta, (rd: any) => {
        const previousRoute = _.find(previousRoutes, ['id', rd.id]);
        return previousRoute ? previousRoute.updatedAt < rd.updatedAt : true;
      })


      //Clear features from datalayer
      const routeIdsToRemove = _.map(routesToRemove.concat(routesToUpdate), 'id');
      this.removeRoutesByIds(routeIdsToRemove);

      //Add routes features to datalayer
      this.setRoutes(_.concat(routesToAdd, routesToUpdate));

      if (!!currentRoutes?.length && !previousRoutes?.length) {
        this.centerMap();
      }

    }

    if (changes.depots && !changes.depots.isFirstChange()) {
      this.depotMarkers = this.mapsCommonService.getDepotMarkers(this.depots);
    }

    if (changes.agents) {
      this.setAgentMarkers(this.agents);
    }

    if (changes.stopsClusters) {
      this.circles = this.stopsClusters?.length ?
        _.map(this.stopsClusters, (sc: StopsClusterModel) => {
          return this.mapsCommonService.getPlanningCluster(sc)
        }) :
        [];
    }

    // Hide Routes Changed
    if (changes.hiddenRoutesAgentIds && !changes.hiddenRoutesAgentIds.isFirstChange()) {
      this.setRoutesStyle();
      // if (!_.isEqual(changes.hiddenRouteIds.previousValue, changes.hiddenRouteIds.currentValue)) {
      //   this.filters.routes = !_.isEqual(this.routes.length, this.hiddenRouteIds.length);
      //
      //   // Set feature style by its properties
      //   this.setRoutesStyle();
      // }
    }

    // un Routed Stops Changed
    if (changes.panelJobs && !changes.panelJobs.isFirstChange()) {

      const currentJobs = changes.panelJobs.currentValue;
      const previousJobs = changes.panelJobs.previousValue;

      const jobsToAdd = _.differenceBy(currentJobs, previousJobs, 'id');
      const jobsToRemove = _.differenceBy(previousJobs, currentJobs, 'id');

      if (jobsToRemove?.length) {
        const stopsToRemove = _.flatMap(jobsToRemove, 'stops');
        this._removeUnRoutedMarkers(_.map(stopsToRemove, 'id'));
      }

      if (jobsToAdd?.length) {
        this.setUnRoutedMarkersOnLayer(jobsToAdd);
      }

      if (!currentJobs?.length && !!previousJobs?.length) {
        this.centerMap();
      }
    }

    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()) {
      this.mapPolygons = this.mapsCommonService.buildPolygons(this.serviceAreas, this.filters.serviceAreas);
    }

    if (changes.selectedJobIds && !changes.selectedJobIds.isFirstChange()) {
      // Set feature style by its properties
      this.$timeout(0).then(() => {
        if (this.unRoutedDataLayerRef) {
          this.unRoutedDataLayerRef.setStyle((feature) => {
            return this.unRoutedFeatureStyle(feature);
          });
        }

        if (this.routesDataLayerRef) {
          // Set feature style by its properties
          this.setRoutesStyle();
        }
      })
    }

    if (changes.zoomActivityId && !changes.zoomActivityId.isFirstChange()) {
      if (this.routesDataLayerRef) {
        let activityMarker;
        let routeId;
        let holderId;

        this.routesDataLayerRef.forEach((feature) => {
          const featureId = feature.getProperty('id')
          if (featureId === this.zoomActivityId) {
            const coordinates = feature.getProperty('coordinates');
            routeId = feature.getProperty('routeId')
            holderId = feature.getProperty('holderId')

            activityMarker = new google.maps.MVCObject();
            activityMarker.set('coords', {'latitude': coordinates.lat, 'longitude': coordinates.lng});
          }
        });

        if (!!activityMarker) {
          this.mapsCommonService.centerMapByBounds(this.map, [activityMarker]);
          if (_.includes(this.hiddenRoutesAgentIds, holderId)) {
            this.onHiddenRoutesAgentIdsChange({
              ids: _.filter(this.hiddenRoutesAgentIds, (aid) => {
                return aid !== holderId;
              })
            });
          }
          this.$timeout(100).then(() => {
            this.map.zoom = 16;
          })
        }
      }
    }

    if (changes.selectedActivityId && !changes.selectedActivityId.isFirstChange()) {
      const currentSelectedActivityId = _.get(changes, 'selectedActivityId.currentValue', undefined),
        previousSelectedActivityId = _.get(changes, 'selectedActivityId.previousValue', undefined);

      if (this.routesDataLayerRef) {
        // Set feature style by its properties
        this.setRoutesStyle();
      }

    }

    if (changes.highlightedActivityId && !changes.highlightedActivityId.isFirstChange()) {
      if (_.isFunction(this.routedMarkersControl.getGMarkers)) {
        const routeMarkers = this.routedMarkersControl.getGMarkers(),
          currentHighlightedId = changes.highlightedActivityId.currentValue,
          previousHighlightedId = changes.highlightedActivityId.previousValue;

        const markersToUpdate = _.chain(routeMarkers)
          .map((marker, i) => {
            return {ref: marker, index: i}
          })
          .filter((m) => {
            const markerId = m.ref.model.id;
            return markerId === currentHighlightedId || markerId === previousHighlightedId;
          })
          .value();

        _.forEach(markersToUpdate, (m, i) => {
          const isHighlighted = _.isEqual(m.ref.model.id, this.highlightedActivityId);
          this.setGoogleMarkerIcon(m.ref, this.selectedActivityId, this.highlightedActivityId);
          m.ref.setZIndex(this.mapsCommonService.getRoutedActivityMarkerZIndex(m.ref, isHighlighted, m.ref.model.markerIndex))
        });

        // _.forEach(routeMarkers, function(routedMarker, i) {
        //     var isHighlighted = _.isEqual(routedMarker.models.id, ctrl.highlightedActivityId);
        //     _setGoogleMarkerIcon(routedMarker, ctrl.selectedActivityId, ctrl.highlightedActivityId);
        //     routedMarker.setZIndex(mapsCommon.getRoutedActivityMarkerZIndex(routedMarker, isHighlighted, i))
        // });
      }
    }
  }


  // ******************************
  //        Public methods
  // ******************************

  // onToggleUnRouted() {
  //   if (!this.filters.unRouted) {
  //     this.map.doCluster = false;
  //   }
  //   this.setUnRoutedStopsVisibility();
  // }

  onToggleUnRouted(isEnabled) {
    if (isEnabled) {
      if (this.map.doCluster) {
        this.onSetClusters(true);
        this.filters.unRouted = false;
      } else {
        this.filters.unRouted = true;
      }
    } else {
      this.filters.unRouted = false;
      this.clearCluster();
    }
  }

  private _removeUnRoutedMarkers(removeIds?) {
    if (this.unRoutedDataLayerRef) {
      this.unRoutedDataLayerRef.forEach((feature) => {
        if (!removeIds || _.includes(removeIds, feature.getProperty('id'))) {
          this.unRoutedDataLayerRef.remove(feature);
        }
      });
    }
  }

  private setUnRoutedMarkersOnLayer(jobs) {
    if (this.unRoutedDataLayerRef) {
      // const stops = _.flatMap(jobs, 'stops');
      const jobsCopy = angular.copy(jobs);
      const stops = [];
      jobsCopy?.forEach((j) => {
        j.stops.forEach((s) => {
          s.pricePlanProgramType = j.pricePlanProgramType;
          stops.push(s);
        })
      })

      let geoJson = this.mapsCommonService.convertStopsToGeoJson(stops, this.isAllowDraggingStops);

      // Add routes to layer
      this.unRoutedDataLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.unRoutedDataLayerRef.setStyle((feature) => {
        return this.unRoutedFeatureStyle(feature);
      });

      if (!!this.map.doCluster) {
        this.reInitCluster();
      }
    }
  }

  private unRoutedFeatureStyle(feature) {
    let jobId = feature.getProperty('jobId'),
      purpose = feature.getProperty('purpose'),
      pricePlanProgramType = feature.getProperty('pricePlanProgramType');

    const isSelected = _.indexOf(this.selectedJobIds, jobId) !== -1;

    const text = this.programTypeAliasMap[pricePlanProgramType];
    return {
      visible: true,
      icon: this.mapsCommonService.buildVisitPlanStopIcon(isSelected, this.purposeToColor[purpose], false, text)
      // icon: this.mapsCommonService.getTaskMarkerIconNew(purpose, undefined, isSelected)
    }
  }

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic = false;
    }
  }

  centerMap() {
    this.$timeout(500).then(() => {
      const markers = this.getAllMarkers();
      this.mapsCommonService.centerMapByBounds(this.map, markers);
    })
  }

  onToggleRoutes() {
    // const ids = this.filters.routes ? [] : _.map(this.routes, 'resource.agentId');
    // this.onHiddenRoutesAgentIdsChange({ids: ids});
  }

  onToggleServiceAreas() {
    _.forEach(this.mapPolygons, (mapPolygon) => {
      mapPolygon.visible = this.filters.serviceAreas;
    });
  }

  onToggleClusters(isEnabled) {
    this.filters.clusters = isEnabled;
  }

  // function onRoutedMarkerSelect(marker, eventName, model) {
  //     if (model.type === 'STOP') {
  //         ctrl.onRoutedStopSelect({stop: model.ref})
  //     }
  // }

  onCloseTooltip() {
    this.tooltipOptions.visible = false;
  }

  onSetClusters(isEnabled) {
    this.map.doCluster = isEnabled;

    if (isEnabled) {
      this.reInitCluster();
    } else {
      this.clearCluster();
      this.filters.unRouted = true;
    }
  }

  reInitCluster() {
    if (this.unRoutedDataLayerRef) {

      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      } else {
        this.markerCluster = new MarkerClusterer(this.mapRef, null, {
          gridSize: this.clusterGridSizes.M,
          maxZoom: 12,
          styles: [
            {
              height: 49,
              width: 49,
              url: 'assets/images/icons/cluster/small.svg',
              textColor: '#424242',
              textSize: 14,
              fontWeight: 'bold'
            },
            {
              height: 64,
              width: 64,
              url: 'assets/images/icons/cluster/large.svg',
              textColor: '#424242',
              textSize: 14,
              fontWeight: 'bold'
            }],
          zoomOnClick: true
        });
      }

      this.unRoutedDataLayerRef.forEach((feature) => {
        const id = feature.getProperty('id'),
          purpose = feature.getProperty('purpose'),
          status = feature.getProperty('status'),
          jobId = feature.getProperty('jobId'),
          pricePlanProgramType = feature.getProperty('pricePlanProgramType');

        const text = this.programTypeAliasMap[pricePlanProgramType];

        const isSelected = _.indexOf(this.selectedJobIds, jobId) !== -1;

        const marker = new google.maps.Marker({
          position: feature.getGeometry().get(),
          icon: this.mapsCommonService.buildVisitPlanStopIcon(isSelected, this.purposeToColor[purpose], false, text)
          // icon: this.mapsCommonService.getTaskMarkerIconNew(purpose, status, isSelected)
        });
        this.markerCluster.addMarker(marker);
      });

      this.filters.unRouted = false;
      this.markerCluster.repaint();
    }
  }

  clearCluster() {
    if (this.markerCluster) {
      const clusterMarks = this.markerCluster.getMarkers();
      for (let i in clusterMarks) {
        clusterMarks[i].setMap(null);
      }
      this.markerCluster.clearMarkers();
    }
  }


  // ******************************
  //        Private methods
  // ******************************

  private setAgentMarkers(agents: VisitScheduleResourceHolderExt[]) {
    const agentsHomeAddress = [];
    _.forEach(agents, (agent) => {
      if (agent.address) {
        const agentCopy: any = angular.copy(agent);
        agentCopy.icon = this.mapsCommonService.getAgentIcon(agent);

        agentsHomeAddress.push(agentCopy);
      }
    })

    this.agentsHomeAddress = agentsHomeAddress;
  }

  private _activityOrderIds(draggedActivity, toActivities, polylinePath) {
    // Step 1: Project each existing marker onto polyline
    const markersWithPos = toActivities.map(m => ({
      id: m.id,
      stopIds: m.stopIds?.length ? m.stopIds : [m.stopId],
      positionOnLine: this.mapUtilsService.projectPointOntoPolyline(
        new google.maps.LatLng(m.address.location.lat, m.address.location.lng),
        polylinePath
      )
    }));

    const draggedActivityGeometry = draggedActivity.getGeometry().get()
    // Step 2: Project dragged marker
    const draggedPos = this.mapUtilsService.projectPointOntoPolyline(
      new google.maps.LatLng(draggedActivityGeometry.lat(), draggedActivityGeometry.lng()),
      polylinePath
    );

    const draggedActivityStopIds = draggedActivity.getProperty('stopIds')?.length ? draggedActivity.getProperty('stopIds') : [draggedActivity.getProperty('stopId')]
    // Step 3: Insert dragged marker in correct position
    let inserted = false;
    let newOrder: any = [];
    for (let i = 0; i < markersWithPos.length; i++) {
      if (!inserted && draggedPos < markersWithPos[i].positionOnLine) {
        newOrder = newOrder.concat(draggedActivityStopIds); // insert before current
        inserted = true;
      }
      newOrder = newOrder.concat(markersWithPos[i].stopIds); // insert before current
    }
    if (!inserted) {
      // If it's after the last marker
      newOrder = newOrder.concat(draggedActivityStopIds); // insert before current
    }

    return newOrder;
  }

  private setRoutes(routes) {
    if (this.routesDataLayerRef) {

      _.forEach(routes, (r) => {
        const geoJson =
          this.mapsCommonService.convertRoutedActivitiesToGeoJson(r, this.agentColorMap[r.resource.agentId], this.isAllowDraggingStops);

        // Add routes to layer
        this.routesDataLayerRef.addGeoJson(geoJson);

        // Set feature style by its properties
        this.setRoutesStyle();
      })
    }
  }

  private setRoutesStyle() {
    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.setStyle((feature) => {
        const routeId = feature.getProperty('routeId'),
          holderId = feature.getProperty('holderId'),
          jobIds = feature.getProperty('jobId') ? [feature.getProperty('jobId')] : (feature.getProperty('jobIds') || []),
          type = feature.getProperty('type'),
          isVisible = _.includes(this.hiddenRoutesAgentIds, holderId) ? false : this.filters.routes,
          isSelected = jobIds.some(jobId => this.selectedJobIds?.includes(jobId));
        // isSelected = _.isEqual(feature.getProperty('id'), this.selectedActivityId);
        // isSelected = _.includes(this.selectedJobIds, jobId);
        let jobProgramTypeAlias;
        if (feature.getProperty('jobId') && (type !== 'START') && (type !== 'END')) {
          const job = this.jobsMap[feature.getProperty('jobId')];
          jobProgramTypeAlias = this.programTypeAliasMap[job?.pricePlanProgramType] ? this.programTypeAliasMap[job?.pricePlanProgramType] : job.pricePlanProgramType.charAt(0);
        }

        return this.mapsCommonService.getActivityFeatureStyle(feature, isVisible, isSelected, this.isDisplayRetrips, jobProgramTypeAlias);
      });
    }
  }

  private removeRoutesByIds(routeIdsToRemove) {
    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.forEach((feature) => {
        if (!routeIdsToRemove || _.includes(routeIdsToRemove, feature.getProperty('routeId'))) {
          this.routesDataLayerRef.remove(feature);
        }
      });
    }
  }

  private getAllMarkers() {
    const markers = [];
    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.forEach((feature) => {
        const featureType = feature.getProperty('type'),
          isStop = _.isEqual(featureType, 'STOP'),
          isGroup = _.isEqual(featureType, 'GROUP');

        if (isStop || isGroup) {
          const coordinates = feature.getProperty('coordinates');
          const fakeMarker = new google.maps.MVCObject();
          fakeMarker.set('coords', {'latitude': coordinates.lat, 'longitude': coordinates.lng});
          markers.push(fakeMarker);
        }
      });
    }
    if (this.unRoutedDataLayerRef) {
      this.unRoutedDataLayerRef.forEach((feature) => {
        const coordinates = feature.getProperty('coordinates');
        const fakeMarker = new google.maps.MVCObject();
        fakeMarker.set('coords', {'latitude': coordinates.lat, 'longitude': coordinates.lng});
        markers.push(fakeMarker);
      });
    }
    return markers;
  }

  private setGoogleMarkerIcon(marker, selectedId, highlightedId) {
    const modelRef = marker.model,
      isStop = _.isEqual(modelRef.type, 'STOP'),
      isGroup = _.isEqual(modelRef.type, 'GROUP');

    const icon = (isStop || isGroup) ?
      this.mapsCommonService.buildActivityIcon(
        _.isEqual(modelRef.id, selectedId),
        _.isEqual(modelRef.id, highlightedId),
        modelRef.routeColor,
        isGroup,
        modelRef.markerIndex + 1
      ) :
      this.mapsCommonService.buildStartEndPointIcon(
        _.isEqual(modelRef.id, highlightedId)
      );
    marker.setIcon(icon);
  }

  private setActivityInfoWindow(jobId, agentName, model, lat, lng, details?: VisitScheduleActivityDetailsModel) {
    this.jobInfoWindow.coords = {
      lat: lat,
      latitude: lat,
      lng: lng,
      longitude: lng
    };

    const jobRef = _.find(this.jobs, (j) => {
      return j.id === jobId;
    })

    const branchNames = details?.branchReferences ?
      _getNames(_.map(details.branchReferences, 'name'), 3) :
      '';

    this.jobInfoWindowModel = {
      id: model.id,
      eta: model.eta,
      address: model.address,
      routeId: model.routeId,
      accountName: model.stopActivities?.length ? model.stopActivities[0].accountName : model.accountName,
      branchName: branchNames,
      notBefore: model.notBefore,
      notAfter: model.notAfter,
      packages: model.packages,
      tagNames: jobRef?.tags,
      skills: jobRef?.requiredSkills,
      stopType: model.stopType,
      agentName: agentName,
      userZoneId: this.userZoneId,
      timezoneOffset: this.timezoneOffset
    };
    this.jobInfoWindow.show = true;

    function _getNames(names: string[], maxCount?: number) {
      let string = '';
      if (!names || !names.length) {
        return '';
      }

      let addedCount = 0;
      _.forEach(names, (name, i) => {
        addedCount += 1;
        string += name;
        if (i + 1 < names.length && i < (maxCount || 0)) {
          string += ', '
        }
      });

      if (!!maxCount && addedCount < names.length) {
        string += ` +${names.length - addedCount}`
      }
      return string;
    }
  }

  private _setAgentsInfoWindows(agentIds?) {
    this.agentsHomeAddress.forEach((a: VisitScheduleResourceHolderExt) => {
      if (!agentIds || _.includes(agentIds, a.id)) {
        let coordinates = {
          lat: a?.address.location?.latitude,
          lng: a?.address.location?.longitude
        };


        const name = this.$filter('userName')(a.agentReference);
        const address = this.$filter('bringozAddress')(a.address);

        const eventMarker = new google.maps.MVCObject();
        eventMarker.set('position', coordinates);

        const infowindow = new google.maps.InfoWindow({
          content:  '<span class="br-body-2 font-weight-600">' + name + '</span>'
            + '<br>'
            + '<span class="br-body-2 margin-top-10">' + address + '</span>',
          pixelOffset: new google.maps.Size(0, -20),
          disableAutoPan: false
        });
        infowindow.open(this.mapRef, eventMarker);
        this.agentsInfoWindows.push(infowindow);
      }
    });
  }

  private _clearAllAgentsInfoWindows() {
    _.forEach(this.agentsInfoWindows, (infoWindow) => {
      infoWindow.close();
    })
    this.agentsInfoWindows = [];
  }

  private _setAccountsInfoWindows(accounts: AccountModel[]) {
    accounts.forEach((account) => {
      if (!account) {
        return;
      }

      const coordinates = {
        lat: account.address?.location.latitude,
        lng: account.address?.location.longitude
      };
      const address = this.$filter('bringozAddress')(account.address);
      const eventMarker = new google.maps.MVCObject();

      eventMarker.set('position', coordinates);

      const infowindow = new google.maps.InfoWindow({
        content:  '<span class="br-body-2 font-weight-600">' + account.name + '</span>'
          + '<br>'
          + '<span class="br-body-2">' + address + '</span>',
        pixelOffset: new google.maps.Size(0, -20),
        disableAutoPan: false
      });

      infowindow.open(this.mapRef, eventMarker);
      this.accountsInfoWindows.push(infowindow);
    });
  }

  private _clearAllAccountsInfoWindows() {
    _.forEach(this.accountsInfoWindows, (infoWindow) => {
      infoWindow.close();
    });

    this.accountsInfoWindows = [];
  }

  private unsetActivityInfoWindow() {
    this.hoveringTaskId = undefined;
    this.jobInfoWindowModel = undefined;
    this.jobInfoWindow.show = false;
  }

  private getJobIdsByBounds(bounds: google.maps.LatLngBounds) {
    var jobIds = [];

    if (!!this.filters.unRouted && !!this.unRoutedDataLayerRef) {
      this.unRoutedDataLayerRef.forEach((feature) => {
        const coordinates = feature.getProperty('coordinates'),
          activityJobIds = feature.getProperty('jobId') ? [feature.getProperty('jobId')] : feature.getProperty('jobIds');

        if (bounds.contains({lat: coordinates.lat, lng: coordinates.lng})) {
          jobIds = jobIds.concat(activityJobIds);
        }
      });
    }

    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.forEach((feature) => {
        const coordinates = feature.getProperty('coordinates');
        const holderId = feature.getProperty('holderId');
        if ((!_.includes(this.hiddenRoutesAgentIds, holderId)) &&
          (coordinates && coordinates.lat && coordinates.lng) &&
          (bounds.contains({lat: coordinates.lat, lng: coordinates.lng}))
        ) {
          const activityJobIds = feature.getProperty('jobId') ? [feature.getProperty('jobId')] : feature.getProperty('jobIds');

          if (activityJobIds.length) {
            jobIds = jobIds.concat(activityJobIds);
          }
        }
      });
    }

    return jobIds;
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('visitPlanRoutesMap', {
    bindings: {
      visitPlan: '<',
      routes: '<',
      jobs: '<?',
      agents: '<?',
      panelJobs: '<?',
      depots: '<',
      stopsClusters: '<',
      hiddenRoutesAgentIds: '<',
      unRoutedStops: '<',
      serviceAreas: '<',
      suggestions: '<?',
      selectedJobIds: '<?',
      selectedActivityId: '<?',
      zoomActivityId: '<?',
      highlightedActivityId: '<?',
      isDisplayRetrips: '<?',
      isValidateRouteVehicles: '<?',
      isAllowDraggingStops: '<?',
      isAllowDraggingIntoDispatchedRoute: '<?',
      agentColorMap: '<?',
      programTypeAliasMap: '<?',
      onRoutedJobSelect: '&',
      onPanelJobSelect: '&',
      onUnRoutedMultipleJobsSelect: '&',
      onActivityHover: '&',
      onActivityHighlight: '&',
      onRoutedActivitySelect: '&',
      onAddStopsToRoute: '&',
      onHiddenRoutesAgentIdsChange: '&',
      onSelectRoute: '&',
      onViewJob: '&',
      onChangeRouteResource: '&',
      selectedServiceIdsChanged: '&',
      onMoveActivity: '&'
    },
    template: require('./visit-plan-routes-map.html').default,
    controller: VisitPlanRoutesMapComponent
  });
